module.exports = (client) => {
    client.use(require('./libs/auth-login'));
    client.use(require('./libs/product'));
    client.use(require('./libs/release'));
    client.use(require('./libs/admin'));
    client.use(require('./libs/asset'));
    client.use(require('./libs/os'));
};
